{
  "single": "ha",
  "multiple": "han",
  "updated": "actualizado",
  "builder": "el builder",
  "others": "otros",
  "and": "y",
  "for": "de",
  "emptyAlerts": "No hay alertas disponibles",
  "noteAddedOn": "escrito una nota en",
  "in": "de",
  "kudosText": "kudos en",
  "kudosSingle": "dio",
  "kudosMultiple": "dieron",
  "published": "publicado",
  "multipleBuilder": "los builders",
  "en": "en",
  "to": "en",
  "a": "una",
  "an": "un",
  "project": "proyecto",
  "eventName": "el evento <1>{{name}}</1>",
  "hubName": "del hub <1>{{name}}</1>",
  "Question": "Pregunta",
  "Offer": "Oferta",
  "Announcement": "Anuncio",
  "Brainstorm": "Lluvia de idea",
  "The": "El",
  "the": "el",
  "startDate": "fecha de inicio",
  "endDate": "fecha final",
  "type": "tipo de evento",
  "location": "ubicación",
  "description": "descripción",
  "details": "details",
  "haveBeenUpdated": "ha sido actualizado",
  "hasBeenUpdated": "Ha sido actualizado",
  "hasBeenDeleted": "ha sido eliminado",
  "postedIn": "ha hecho una publicación en",
  "postedIn_plural": "han hecho una publicación en",
  "repliedTo": "ha respondido a",
  "repliedTo_plural": "han respondido a",
  "yourPostOn": "tu publicación en",
  "aPostYouCommentedOn": "también ha comentado el post en",
  "aPostYouCommentedOn_plural": "también han comentado el post en",
  "repliedToAPostYouCommentedOn": "le gusta tu publicación en",
  "repliedToAPostYouCommentedOn_plural": "les gusta tu publicación en",
  "gaveBoostOnReply": "le gusta tu comentario en",
  "gaveBoostOnReply_plural": "les guesta tu comentario en",
  "announcementCreated": "Hay un anuncio de",
  "lastBeen": "desde la última vez que estuviste",
  "answeredAQuestion": "respondió una pregunta",
  "answeredYourQuestion": "respondió tu pregunta",
  "added": "added",
  "gave": "gave",
  "kudosToYour": "felicitaciones a tu",
  "updvotedYourAns": "votó a favor de su respuesta",
  "youWereAddedToThe": "Te han añadido al",
  "group": "grupo"
}
